import { useState, useRef } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Container from '@material-ui/core/Container'
import orderBy from 'lodash/orderBy'
import useTranslate from '../i18n/useTranslate'
import { useQueryParam } from 'use-query-params'

import Panel from '../component/um/officer/Panel'
import Result from '../component/um/officer/Result'
import Dialog, { DialogType } from '../control/dialog/dialog'

import { useSearchOfficer, Keyword, Order } from '../services/um/useSearchOfficer'
import { useDeleteOfficer } from '../services/um/useDeleteOfficer'
import { Grid } from '@material-ui/core'
import SearchAccordion from '../control/accordion/SearchAccordion'

const Member = () => {
    const classes = useStyles()
    const translate = useTranslate()
    const { deleteOfficer } = useDeleteOfficer()
    const { officers, setOfficers, searchOfficers } = useSearchOfficer()
    const [keyword, setKeyword] = useQueryParam('keyword')
    const [usergroupID, setUsergroupID] = useQueryParam('usergroup')
    const [configDialog, setConfigDialog] =
        useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()
    const dialogTwoRef = useRef<Record<string, Function>>()
    const [order, setOrder] = useState<Order>('desc')

    const onSearch = (values: Keyword) => {
        setKeyword(values.keyword)
        setUsergroupID(values.usergroupID)
        searchOfficers(values, order)
    }

    const onSort = (value: Order) => {
        const newOfficers = orderBy(officers, ['updatedDate', 'createdDate'], [order])
        setOrder(value)
        setOfficers(newOfficers)
    }

    const onReset = () => {
        searchOfficers()
    }

    const onRefDialogTwo = (func: Record<string, Function>) => {
        dialogTwoRef.current = func
    }

    const onDelete = (userID: number | string) => {
        setConfigDialog({
            title: translate.get('ALERT.TITLE.NOTIFICATION'),
            content: translate.get('UM.USERGROUP.DELETE-ALERT-CONTENT'),
            type: 'alert-confirm',
            onClickConfirm: () => confirmDelete(userID),
        })

        dialogTwoRef.current?.openDialog()
    }

    const confirmDelete = async (userID: string | number) => {
        const { result } = await deleteOfficer(userID)

        if (result?.message == 'success') {
            searchOfficers()
            setConfigDialog({
                title: translate.get('ALERT.TITLE.NOTIFICATION'),
                content: translate.get('ALERT.CONTENT.DELETE_SUCCESS'),
                type: 'alert-message',
            })
        }
    }

    const handleEnter = (values: Keyword) => {
        onSearch(values)
    }

    return (
        <Container maxWidth="lg">
            <Grid container>
                <Grid item xs={12}>
                    <SearchAccordion title={translate.get('UM.USERGROUP.OFFICER.HEADER')}>
                        <Grid item xs={12}>
                            <Panel
                                onSearch={onSearch}
                                onReset={onReset}
                                initialValues={{ keyword, usergroupID }}
                                onEnter={handleEnter}
                            />
                        </Grid>
                    </SearchAccordion>
                </Grid>
                <Grid item xs={12}>
                    <Result order={order} officers={officers} onDelete={onDelete} onSort={onSort} />
                </Grid>
                <Dialog onRef={onRefDialogTwo} {...configDialog} />
            </Grid>
        </Container>
    )
}

const useStyles = makeStyles((theme) => ({
    typo: {
        fontWeight: 'bold',
    },
    paper: {
        padding: theme.spacing(2),
    },
    title: {
        marginBottom: '0px',
    },
}))

export default Member
